import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const SALE_API_URL = `${API_HOST}/api/sale`;
const SALE_ACTIVITY_API_URL = `${SALE_API_URL}/activity`;
const SALE_ACTIVITY_CATEGORY_API_URL = `${SALE_API_URL}/activityCategory`;
const SALE_ACTIVITY_CONFIGURATION_API_URL = `${SALE_API_URL}/activityConfiguration`;
const SALE_ACTIVITY_ORDER_API_URL = `${SALE_API_URL}/activity/order/`;

function* createSaleActivity() {
  yield takeEvery(actions.CREATE_SALE_ACTIVITY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], SALE_ACTIVITY_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_SALE_ACTIVITY_ENDED });
    }
  });
}

function* updateSaleActivity() {
  yield takeEvery(actions.UPDATE_SALE_ACTIVITY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], SALE_ACTIVITY_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_SALE_ACTIVITY_ENDED });
    }
  });
}

function* deleteSaleActivities() {
  yield takeEvery(actions.DELETE_SALE_ACTIVITIES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], SALE_ACTIVITY_API_URL, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_SALE_ACTIVITIES_ENDED });
    }
  });
}

function* searchSaleActivities() {
  yield takeEvery(actions.SEARCH_SALE_ACTIVITIES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SALE_ACTIVITY_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_SALE_ACTIVITIES_ENDED });
    }
  });
}

function* findSaleActivity() {
  yield takeEvery(actions.FIND_SALE_ACTIVITY, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SALE_ACTIVITY_API_URL}/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_SALE_ACTIVITY_ENDED });
    }
  });
}

function* findSaleActivityCategory() {
  yield takeEvery(actions.FIND_SALE_ACTIVITY_CATEGORY, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SALE_ACTIVITY_CATEGORY_API_URL}/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_SALE_ACTIVITY_CATEGORY_ENDED });
    }
  });
}

function* createSaleActivityCategory() {
  yield takeEvery(actions.CREATE_SALE_ACTIVITY_CATEGORY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], SALE_ACTIVITY_CATEGORY_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_SALE_ACTIVITY_CATEGORY_ENDED });
    }
  });
}

function* updateSaleActivityCategory() {
  yield takeEvery(actions.UPDATE_SALE_ACTIVITY_CATEGORY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], SALE_ACTIVITY_CATEGORY_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_SALE_ACTIVITY_CATEGORY_ENDED });
    }
  });
}

function* deleteSaleActivityCategories() {
  yield takeEvery(actions.DELETE_SALE_ACTIVITY_CATEGORIES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], SALE_ACTIVITY_CATEGORY_API_URL, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_SALE_ACTIVITY_CATEGORIES_ENDED });
    }
  });
}

function* searchSaleActivityCategories() {
  yield takeEvery(actions.SEARCH_SALE_ACTIVITY_CATEGORIES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SALE_ACTIVITY_CATEGORY_API_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_SALE_ACTIVITY_CATEGORIES_ENDED });
    }
  });
}

function* getSaleActivityHandlingFeeConfiguration() {
  yield takeEvery(actions.GET_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SALE_ACTIVITY_CONFIGURATION_API_URL}/handlingFee`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION_ENDED });
    }
  });
}

function* updateSaleActivityHandlingFeeConfiguration() {
  yield takeEvery(actions.UPDATE_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${SALE_ACTIVITY_CONFIGURATION_API_URL}/handlingFee`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION_ENDED });
    }
  });
}

function* getSaleActivityReceiptConfiguration() {
  yield takeEvery(actions.GET_SALE_ACTIVITY_RECEIPT_CONFIGURATION, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SALE_ACTIVITY_CONFIGURATION_API_URL}/receipt`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_SALE_ACTIVITY_RECEIPT_CONFIGURATION_ENDED });
    }
  });
}

function* updateSaleActivityReceiptConfiguration() {
  yield takeEvery(actions.UPDATE_SALE_ACTIVITY_RECEIPT_CONFIGURATION, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${SALE_ACTIVITY_CONFIGURATION_API_URL}/receipt`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_SALE_ACTIVITY_RECEIPT_CONFIGURATION_ENDED });
    }
  });
}

function* searchSaleActivityOrders() {
  yield takeEvery(actions.SEARCH_SALE_ACTIVITY_ORDERS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SALE_ACTIVITY_ORDER_API_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_SALE_ACTIVITY_ORDERS_ENDED });
    }
  });
}

function* voucherSaleActivityOrderRefund() {
  yield takeEvery(actions.VOUCHER_SALE_ACTIVITY_ORDER_REFUND, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SALE_ACTIVITY_ORDER_API_URL}refund`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.VOUCHER_SALE_ACTIVITY_ORDER_REFUND_ENDED });
    }
  });
}

function* voucherSaleActivityOrderRefundByManually() {
  yield takeEvery(actions.VOUCHER_SALE_ACTIVITY_ORDER_REFUND_BY_MANUALLY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${SALE_ACTIVITY_ORDER_API_URL}manuallyRefund`,
        formData,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.VOUCHER_SALE_ACTIVITY_ORDER_REFUND_BY_MANUALLY_ENDED });
    }
  });
}

function* voucherSaleActivityOrderPartiallyRefund() {
  yield takeEvery(actions.VOUCHER_SALE_ACTIVITY_ORDER_PARTIALLY_REFUND, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${SALE_ACTIVITY_ORDER_API_URL}partiallyRefund`,
        formData,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.VOUCHER_SALE_ACTIVITY_ORDER_PARTIALLY_REFUND_ENDED });
    }
  });
}

function* voucherSaleActivityOrderRejectRefundApplication() {
  yield takeEvery(
    actions.VOUCHER_SALE_ACTIVITY_ORDER_REJECT_REFUND_APPLICATION,
    function* (action) {
      const { id, onSuccess } = action;
      try {
        const res = yield call(
          [axios, 'post'],
          `${SALE_ACTIVITY_ORDER_API_URL}${id}/rejectRefundApplication`,
        );
        if (isFunction(onSuccess)) {
          yield call(onSuccess, res.data);
        }
      } catch (err) {
        yield handleError(err);
      } finally {
        yield put({ type: actions.VOUCHER_SALE_ACTIVITY_ORDER_REJECT_REFUND_APPLICATION_ENDED });
      }
    },
  );
}

function* getRefundAmountInfo() {
  yield takeEvery(actions.GET_REFUND_AMOUNT_INFO, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SALE_ACTIVITY_ORDER_API_URL}${id}/getRefundAmountInfo`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_REFUND_AMOUNT_INFO_ENDED });
    }
  });
}

function* issueOrder() {
  yield takeEvery(actions.ISSUE_VOUCHER_SALE_ACTIVITY_ORDER, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SALE_ACTIVITY_ORDER_API_URL}${id}/issueOrder`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      const { onError } = action;
      if (isFunction(onError)) {
        yield call(onError, err);
      }
      yield handleError(err);
    } finally {
      yield put({ type: actions.ISSUE_VOUCHER_SALE_ACTIVITY_ORDER_ENDED });
    }
  });
}

function* createCreditBySaleActivityOrder() {
  yield takeEvery(actions.CREATE_CREDIT_BY_SALE_ACTIVITY_ORDER, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SALE_ACTIVITY_ORDER_API_URL}issueCredit`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_CREDIT_BY_SALE_ACTIVITY_ORDER_ENDED });
    }
  });
}

function* invalidateReceiptBySaleActivityOrder() {
  yield takeEvery(actions.INVALIDATE_RECEIPT_BY_SALE_ACTIVITY_ORDER, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${SALE_ACTIVITY_ORDER_API_URL}invalidateReceipt`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.INVALIDATE_RECEIPT_BY_SALE_ACTIVITY_ORDER_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createSaleActivity),
    fork(updateSaleActivity),
    fork(deleteSaleActivities),
    fork(searchSaleActivities),
    fork(findSaleActivityCategory),
    fork(createSaleActivityCategory),
    fork(updateSaleActivityCategory),
    fork(deleteSaleActivityCategories),
    fork(searchSaleActivityCategories),
    fork(findSaleActivity),
    fork(getSaleActivityHandlingFeeConfiguration),
    fork(updateSaleActivityHandlingFeeConfiguration),
    fork(getSaleActivityReceiptConfiguration),
    fork(updateSaleActivityReceiptConfiguration),
    fork(searchSaleActivityOrders),
    fork(voucherSaleActivityOrderRefund),
    fork(voucherSaleActivityOrderRefundByManually),
    fork(voucherSaleActivityOrderPartiallyRefund),
    fork(voucherSaleActivityOrderRejectRefundApplication),
    fork(getRefundAmountInfo),
    fork(issueOrder),
    fork(createCreditBySaleActivityOrder),
    fork(invalidateReceiptBySaleActivityOrder),
  ]);
}
